import type { ProductoInfo360Maestro } from './components/ArticuloInfo360Header';

type ClasificacionNavigation = {
  nombreRamo?: string | null;
  nombreLinea?: string | null;
  nombreClase?: string | null;
};

type ProductoConNavigation = ProductoInfo360Maestro & {
  codigoRamoNavigation?: ClasificacionNavigation | null;
  codigoLineaNavigation?: ClasificacionNavigation | null;
  codigoClaseNavigation?: ClasificacionNavigation | null;
};

function firstNonEmpty(...values: Array<string | null | undefined>): string {
  for (const v of values) {
    const t = v?.trim();
    if (t) return t;
  }
  return '';
}

export function resolveNombreRamo(producto: ProductoInfo360Maestro): string {
  const p = producto as ProductoConNavigation;
  return firstNonEmpty(p.nombreRamo, p.codigoRamoNavigation?.nombreRamo, p.codigoRamo);
}

export function resolveNombreLinea(producto: ProductoInfo360Maestro): string {
  const p = producto as ProductoConNavigation;
  return firstNonEmpty(p.nombreLinea, p.codigoLineaNavigation?.nombreLinea, p.codigoLinea);
}

export function resolveNombreClase(producto: ProductoInfo360Maestro): string {
  const p = producto as ProductoConNavigation;
  return firstNonEmpty(p.nombreClase, p.codigoClaseNavigation?.nombreClase, p.codigoClase);
}

export function resolveClasificacionCompleta(producto: ProductoInfo360Maestro): string {
  return [resolveNombreRamo(producto), resolveNombreLinea(producto), resolveNombreClase(producto)]
    .filter(Boolean)
    .join(' · ');
}
